/**
 * Created by Pradeep Kumar on 05/20/2019.
 */

import {Helper} from "@nolimitcity/slot-game/bin/core/utils/Helper";
import { Device } from "@nolimitcity/slot-launcher/bin/interfaces/APIOptions";
import {UserAgent} from "@nolimitcity/slot-game/bin/core/useragent/UserAgent";
import {TombOfNefertitiGameConfig} from "../TombOfNefertitiGameConfig";

export class TombOfNefertitiHelper extends Helper {

    /**
     * @description To get the symbol positions as per individual reel.
     *
     * @param reelId
     * @param symId
     * @param realSymbolPosition
     * @param device
     */
    public static getSymbolPositions(reelId: number, symId: number, realSymbolPosition?: boolean, device?: Device): [number, number] {
        const numOfRows = 3,
            columnIndex = 0;

        if (!device) {
            device = UserAgent.deviceName;
        }
        const reelAreaPositions: [number, number] = [TombOfNefertitiGameConfig.instance.REEL_AREA_POS_X, TombOfNefertitiGameConfig.instance.REEL_AREA_POS_Y];
        const symbolPositionsOnReelArea: [number, number] = Helper.getSymbolPositionsOnReelArea(reelId * numOfRows + symId, columnIndex, realSymbolPosition, device);
        return [reelAreaPositions[0] + symbolPositionsOnReelArea[0], reelAreaPositions[1] + symbolPositionsOnReelArea[1]];
    }
}